module.exports = __webpack_public_path__ + "media/images/sp/brands/sola/store_sapporo-5a63a90edb5e556ed6d0ef82a4067404.webp";